import 'slick-carousel';

const $ = jQuery;

export default {
    init() {
        setupAwardsCarousel();
    }
};

function setupAwardsCarousel() {
    const $blocks = $('.page-block-awards-carousel');

    if (!$blocks.length) {
        return;
    }

    $blocks.each(function() {
        const $container = $(this);
        const $slider = $container.find('.awards-slider');

        const $prevArrow = $container.find('.awards-prev-custom');
        const $nextArrow = $container.find('.awards-next-custom');

        if ($slider.hasClass('slick-initialized')) {
            return;
        }

        $slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    });
}
